import { k as jsxRuntimeExports } from "./doenetml-drNYjJiF.js";
import React__default from "react";
import { u as useDoenetRenderer } from "./useDoenetRenderer-CDZbHBy-.js";
const br = React__default.memo(function Br(props) {
  let { id, SVs } = useDoenetRenderer(props);
  if (SVs.hidden) {
    return null;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx("br", { id });
});
export {
  br as default
};
